import BlackWhiteListList from './BlackWhiteListList';
import BlackWhiteListEdit from './BlackWhiteListEdit';

const blackWhiteLists = {
	list: BlackWhiteListList,
	edit: BlackWhiteListEdit
};

export default blackWhiteLists;
